(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-tree-select", [], factory);
	else if(typeof exports === 'object')
		exports["vue-tree-select"] = factory();
	else
		root["vue-tree-select"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition